import React from 'react';
import Isvg from 'react-inlinesvg';
import { bem, classNameWithModifiers as withMods } from 'helpers/class-name';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { ICONS } from 'constants/icons';
import { intlMessageShape } from 'constants/propTypes';

import Button from 'components/Button';
import { Card } from 'components/Card';
import Message from 'components/Message';
import When from 'components/When';
import appMessages from 'features/App/App.messages';

import './InfoBanner.scss';

const { element, modifier } = bem('info-banner');
export const BANNER_VARIANTS = {
  BLUE: 'BLUE',
  YELLOW: 'YELLOW',
  GRAY: 'GRAY',
  RED: 'RED',
};

const InfoBanner = ({
  callToAction = appMessages.learnMore,
  children,
  className,
  onClick,
  onClose,
  showCloseButton = false,
  subtitle,
  subtitleValues = {},
  title = null,
  titleValues = {},
  hideCTA = false,
  icon = ICONS.marketingGraph,
  variant = BANNER_VARIANTS.BLUE,
  wideButton = false,
}) => {
  const intl = useIntl();
  const closeAriaLabel = intl.formatMessage(appMessages.close);

  return (
    <Card flush collapse className={element('container', className, modifier(variant.toLowerCase()))}>
      <div className={element('content-container')}>
        <div className={element('text-container')}>
          <Isvg className={element('icon')} src={icon} />
          <div className={element('banner-text', 'item')}>
            <When predicate={!!title}>
              <Message as="h6" message={title} values={titleValues} />
            </When>
            <When predicate={!!subtitle}>
              <Message message={subtitle} values={subtitleValues} />
            </When>
          </div>
        </div>
        <div className={element('line-break')} />
        <When predicate={!hideCTA}>
          <Message
            className={withMods(element('cta-button', { wideButton }, 'item'))}
            as={Button}
            message={callToAction}
            onClick={onClick}
          />
        </When>
        <When predicate={showCloseButton}>
          <button className={element('close-btn', { 'ml-auto': hideCTA }, 'mr-0 pr-0')} type="button" onClick={onClose}>
            <Isvg src={ICONS.cardsClose} aria-label={closeAriaLabel} />
          </button>
        </When>
        {children}
      </div>
    </Card>
  );
};

InfoBanner.propTypes = {
  children: PropTypes.node,
  showCloseButton: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  callToAction: PropTypes.shape(intlMessageShape),
  className: PropTypes.string,
  title: PropTypes.shape(intlMessageShape),
  titleValues: PropTypes.shape({}),
  subtitle: PropTypes.shape(intlMessageShape),
  subtitleValues: PropTypes.shape({}),
  hideCTA: PropTypes.bool,
  icon: PropTypes.string,
  variant: PropTypes.oneOf(Object.keys(BANNER_VARIANTS)),
  wideButton: PropTypes.bool,
};

export default InfoBanner;
